import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';

import { useStorage, storage, storageKeys } from '@selfserve/react-hooks';
import {
  CommonLayout,
  StyledContentContainer,
  StyledTitle,
  StyledText,
  StyledLink,
  StyledBoldText,
  StyledEmailSentLogo,
  StyledToast,
} from '@selfserve/react-ui';
import { buttonIds } from '@selfserve/react-utils';
import { withErrorHandling } from '@selfserve/react-hocs';
import { useEmailResend } from '@selfserve/react-hooks';

import { EmailValidation, EmailValidationPayload, useEmailValidationRequest } from '../data';

const StyledVerifyText = styled(StyledText)`
  margin-top: 16px;
`;

export const Verify = withErrorHandling(({ openErrorModal }) => {
  const { t } = useTranslation();
  const [sessionEmail] = useStorage(storage.SESSION, storageKeys.EMAIL);
  const { removeSuccessMessage, onClickHandle, successMessage } =
    useEmailResend<EmailValidationPayload, EmailValidation>(openErrorModal, useEmailValidationRequest);

  return (
    <>
      <Helmet>
        <title>{t('titles.create-account')}</title>
      </Helmet>
      {successMessage && (
        <StyledToast onClose={removeSuccessMessage} severity="success">
          <span>{successMessage}</span>
        </StyledToast>
      )}
      <CommonLayout>
        <StyledContentContainer centered>
          <StyledEmailSentLogo />
          <StyledTitle as="span" className="main-header">
            {t('common.got-email')}
          </StyledTitle>
          <StyledVerifyText className="verify-description" centered>
            {t('common.please-verify-email')}
          </StyledVerifyText>
          <StyledBoldText className="email-address">
            {sessionEmail}
          </StyledBoldText>
          <StyledVerifyText className="verify-description" centered>
            {`${t('common.cant-find-it')} `}
            <StyledLink
              to=""
              onClick={onClickHandle}
              id={buttonIds.resendVerification}
            >
              {t('common.resend')}
            </StyledLink>
          </StyledVerifyText>
        </StyledContentContainer>
      </CommonLayout>
    </>
  );
});
